import {getAllCountries} from '../../components/shared/services/country.service';
import {country} from '../../components/shared/models/country';
import {DEFAULT_COUNTRY_CODE} from '../../config/config';

export const backMixin = {
    methods: {
        async loadCountries(detailsForPack = false) {
            getAllCountries().then(response => {
                this.itemsCountry = response.data['hydra:member'];
                this.itemsCountry = this.itemsCountry.map(item => country(item));
                if (detailsForPack) {
                    this.actualCountry = this.itemsCountry.find(item => item.code == DEFAULT_COUNTRY_CODE);
                    this.itemsCountry = this.itemsCountry.filter(item => item.code != DEFAULT_COUNTRY_CODE);
                    this.isItemsCountry = false;
                    if (this.DomainPack.id != null) {
                        this.loadPackCountryDomain(this.actualDomain.id, this.actualCountry.id);
                    }
                }
            });
        }
    }
};
